module.exports = __webpack_public_path__ + "static/media/clockface-dark.a6688912.png";